const currentYear = new Date().getFullYear();

export const dateTileOptions = [
  { value: 'last30Days', label: 'Last 30 Days' },
  { value: 'last60Days', label: 'Last 60 Days' },
  { value: 'last25Months', label: 'Last 25 Months' },
  { value: 'last6Months', label: 'Last 6 Months' },
  { value: 'thisYear', label: currentYear.toString() },
  { value: 'lastYear', label: (currentYear - 1).toString() },
  {
    value: 'twoYearsPrior',
    label: (currentYear - 2).toString(),
  },
  { value: 'last7Years', label: 'Last 7 Years' },
];

export const userTileOptions = (username: string) => [
  { value: 'allOrders', label: 'Everyone (Default)' },
  { value: 'myOrders', label: `${username ?? ''} (Just Me)` },
];

export const FILTER_DOT_BASE_CLASS_NAME =
  'sui-absolute sui-left-[40px] sui-size-[10px] sui-rounded-full sui-bg-[#f96302] sui-ml-[8px] sui-z-[100]';
